import { Shield } from "lucide-react";
import { useUserRole } from "@/hooks/useUserRole";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useAdminsRoster } from "./admins/useAdminsRoster";
import { AdminRosterRow } from "./admins/AdminRosterRow";
import { GrantAdminCard } from "./admins/GrantAdminCard";

export const AdminsTab = () => {
  const { isSuperAdmin } = useUserRole();
  const {
    callerId,
    roster,
    rosterLoading,
    busyUserId,
    adminCount,
    superCount,
    loadRoster,
    writeAudit,
    promoteToSuper,
    demoteFromSuper,
    revokeAdmin,
  } = useAdminsRoster();

  return (
    <TooltipProvider>
      <div className="space-y-4">
        <Card className="shadow-soft">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Shield className="h-5 w-5 text-primary" /> Current admins
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {!isSuperAdmin && (
              <p className="text-sm text-muted-foreground">
                Read-only view. Only super admins can grant or revoke admin roles.
              </p>
            )}
            {rosterLoading && (
              <div className="space-y-2">
                <Skeleton className="h-16 w-full" />
                <Skeleton className="h-16 w-full" />
              </div>
            )}
            {!rosterLoading && roster.length === 0 && (
              <p className="py-4 text-sm text-muted-foreground">No admins yet.</p>
            )}
            {!rosterLoading && roster.map((row) => {
              const isSelf = row.user_id === callerId;
              const isLastSuper = row.is_super && superCount === 1;
              const isLastAdmin = adminCount === 1;
              return (
                <AdminRosterRow
                  key={row.user_id}
                  row={row}
                  isSelf={isSelf}
                  isLastSuper={isLastSuper}
                  isLastAdmin={isLastAdmin}
                  isSuperAdmin={isSuperAdmin}
                  busy={busyUserId === row.user_id}
                  superCount={superCount}
                  onPromote={() => promoteToSuper(row)}
                  onDemote={() => demoteFromSuper(row)}
                  onRevoke={() => revokeAdmin(row)}
                />
              );
            })}
          </CardContent>
        </Card>

        {isSuperAdmin && <GrantAdminCard reloadRoster={loadRoster} writeAudit={writeAudit} />}
      </div>
    </TooltipProvider>
  );
};
